import template from "./questiontwo.html";
import controller from "./questiontwo.controller";

let questiontwoComponent = {
  restrict: "E",
  bindings: {
    event: "=",
  },
  template,
  controller,
  controllerAs: "vm",
};

export default questiontwoComponent;



// WEBPACK FOOTER //
// ./client/app/scenes/references/scenes/questiontwo/questiontwo.component.js